import { getStructure } from "@/request/view/personal";

const getStructureData = () => {
    return new Promise((resolve, reject) => {
        const staffData = sessionStorage.getItem("noticeStaffData");

        if (staffData) {
            resolve(JSON.parse(staffData));
        }
        const setStructureBuyUser = (list) => {
            list.forEach((item) => {
                item.structureName = item.nickName;
                item.id = `P${item.id}`;
            });
            return list;
        };
        getStructure().then((res) => {
            if (res.code === 200) {
                const flatten = (list) => {
                    list.forEach((item) => {
                        if (item.userList && item.userList.length > 0) {
                            item.children.unshift(...setStructureBuyUser(item.userList));
                        }
                        if (item.children && item.children.length > 0) {
                            flatten(item.children);
                        }
                    });
                };

                flatten(res.data);
                resolve(res.data);
            }
        });
    });
};

const getDepartmentLeader = (staffData, department) => {
    let findDepartMent = null;
    const ite = (list) => {
        list.forEach((item) => {
            if (item.structureName === department) {
                findDepartMent = item;
            }
            if (item.children && item.children.length > 0) {
                ite(item.children);
            }
        });
    };
    ite(staffData);

    if (findDepartMent) {
        const [departmentLeader] = findDepartMent.userList.filter(
            (item) => item.isDL
        );
        return departmentLeader;
    }
};

const getDepartmentStaff = (staffData, nickName) => {
    let findStaff = null;
    const ite = (list) => {
        list.forEach((item) => {
            let findUser = undefined;
            if (item.userList) {
                const [filterStaff] = item.userList.filter((user) => user.nickName === nickName);
                findUser = filterStaff;
            }
            
            if (findUser !== undefined) findStaff = findUser;
            if (item.children && item.children.length > 0) {
                ite(item.children);
            }
        });
    };
    ite(staffData);

    return findStaff
};



export const getEngineeringDepartment = (department) => {
    return new Promise(async (resolve, reject) => {
        const staffData = await getStructureData();
        const departmentLeader = getDepartmentLeader(staffData, department);
        resolve(departmentLeader);
    });
};

export const getStrctreStaff = (nickName) => {
    return new Promise(async (resolve, reject) => {
        const staffData = await getStructureData();
        console.log(staffData, nickName, '++++++++++')
        const departmentLeader = getDepartmentStaff(staffData, nickName);
        resolve(departmentLeader);
    });
}


